
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.33","height":"18.286"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_20186","data-name":"Group 20186","transform":"translate(-154 -18.566)"}},[_c('g',{attrs:{"id":"Group_8569","data-name":"Group 8569","transform":"translate(154.57 18.566)"}},[_c('g',{attrs:{"id":"Group_8564","data-name":"Group 8564","fill":"#fff"}},[_c('path',{attrs:{"id":"Path_1125","data-name":"Path 1125","d":"M383.532 528.157a2.642 2.642 0 01-2.64-2.64 2.473 2.473 0 01.837-1.9l1.8-1.8 1.8 1.8a2.477 2.477 0 01.837 1.9 2.642 2.642 0 01-2.634 2.64zm0-5.075l-1.168 1.166a1.608 1.608 0 00-.574 1.269 1.741 1.741 0 103.482 0 1.605 1.605 0 00-.574-1.269z","transform":"translate(-370.411 -512.268)"}}),_c('path',{attrs:{"id":"Path_1126","data-name":"Path 1126","d":"M377.813 527.96a.771.771 0 01-.388-.1l-6.052-3.495a.78.78 0 01-.285-1.064l4.853-8.407 8.129 4.694a.694.694 0 01-.322 1.295 2.541 2.541 0 00-2.132 1.276l-3.127 5.417a.785.785 0 01-.676.384zm-5.886-4.318l5.844 3.374 3.06-5.3a3.442 3.442 0 012.26-1.659l-6.822-3.938z","transform":"translate(-370.983 -512.668)"}}),_c('path',{attrs:{"id":"Path_1127","data-name":"Path 1127","d":"M378.633 520.015h-.9v-4.7a1.624 1.624 0 00-3.248 0v3.634h-.9v-3.634a2.522 2.522 0 115.044 0z","transform":"translate(-370.832 -512.789)"}}),_c('circle',{attrs:{"id":"Ellipse_108","data-name":"Ellipse 108","cx":".782","cy":".782","r":".782","transform":"translate(6.57 6.444)"}})])])])])
          )
        }
      }
    